import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ENDPOINTS } from '../../../Utils/Endpoints';
import { catColorNormalize } from '../../../Objetos/ColoresModel';
import '../../../Styles/ColoresCatalog.css'; // Reutilizamos estilos estándar

export default function ColoresModal({ open, mode, data, onClose, onSubmit, usedIds = [], inline }) {
    const [variables, setVariables] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [isLoadingVars, setIsLoadingVars] = useState(false);

    const [form, setForm] = useState({
        nombre: '',
        descripcion: '',
        idCatColor: '',
        variable: '',
        valor: '#3c00be',
        activo: true,
        idCategoria: null
    });

    useEffect(() => {
        if (open) {
            const fetchVars = async () => {
                setIsLoadingVars(true);
                try {
                    const [resVars, resCats] = await Promise.all([
                        axios.get(ENDPOINTS.catColores),
                        axios.get(ENDPOINTS.catCategorias)
                    ]);
                    const listVars = (resVars.data || []).map(catColorNormalize);
                    setVariables(listVars);
                    const listCats = (resCats.data || []).map(c => ({
                        idCategoria: c.idCategoria || c.IdCategoria,
                        nombre: c.nombre || c.Nombre
                    }));
                    setCategorias(listCats);
                } catch (e) {
                    console.error("Error loading resources:", e);
                } finally {
                    setIsLoadingVars(false);
                }
            };
            fetchVars();
        }
    }, [open]);

    useEffect(() => {
        if (open) {
            if (mode === 'edit' && data) {
                setForm({
                    nombre: data.nombre || '',
                    descripcion: data.descripcion || '',
                    idCatColor: data.idCatColor || '',
                    variable: data.variable || '',
                    valor: data.valor || '#3c00be',
                    activo: data.activo ?? true,
                    idCategoria: data.idCategoria || null
                });
            } else {
                setForm({
                    nombre: '',
                    descripcion: '',
                    idCatColor: '',
                    variable: '',
                    valor: '#3c00be',
                    activo: true,
                    idCategoria: null
                });
            }
        }
    }, [open, mode, data]);

    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const handleVariableChange = (id) => {
        const idInt = parseInt(id);
        const selected = variables.find(v => v.idColor === idInt);
        setForm(prev => ({
            ...prev,
            idCatColor: idInt,
            variable: selected ? selected.variable : ''
        }));
    };

    const isFormValid = form.nombre && form.idCatColor;

    if (!open) return null;

    // Defines label style explicitly correctly as BLOCK to avoid inline-flex conflict from .roles-title
    const labelStyle = {
        display: 'block',
        fontSize: '0.95rem',
        fontWeight: '800',
        color: '#0f172a',
        marginBottom: '0.5rem'
    };

    const Header = (
        <div
            className="roles-topbar"
            style={{
                marginBottom: '1.5rem',
                paddingRight: 16,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flex: '0 0 auto',
            }}>
            <h3 className="roles-title" style={{ marginRight: 0 }}>
                {mode === 'new' ? 'Nueva Configuración (Color)' : 'Editar Color'}
            </h3>
            <button className="roles-btn" onClick={onClose} aria-label="Cerrar">
                ✕
            </button>
        </div>
    );

    const Body = (
        <div
            style={{
                paddingLeft: '2rem', // Padding interno ajustado
                paddingRight: '2rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '1.5rem',
                overflowY: 'auto',
                flex: '1 1 auto',
                minHeight: 0,
            }}>

            <div>
                <label style={labelStyle}>Nombre (Clave):</label>
                <input
                    className="infoField"
                    value={form.nombre}
                    onChange={(e) => handleChange('nombre', e.target.value)}
                    placeholder="Ej. ColorPrincipal"
                />
            </div>

            <div>
                <label style={labelStyle}>Descripción:</label>
                <input
                    className="infoField"
                    value={form.descripcion}
                    onChange={(e) => handleChange('descripcion', e.target.value)}
                    placeholder="Descripción del color"
                />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem' }}>
                <div>
                    <label style={labelStyle}>Variable (Token):</label>
                    <select
                        className="infoField"
                        value={form.idCatColor}
                        onChange={(e) => handleVariableChange(e.target.value)}
                        disabled={isLoadingVars}
                    >
                        <option value="">Seleccione...</option>
                        {variables.filter(v => {
                            if (mode === 'edit' && data && v.idColor === data.idCatColor) return true;
                            return !usedIds.includes(v.idColor);
                        }).map(v => (
                            <option key={v.idColor} value={v.idColor}>{v.variable}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label style={labelStyle}>Categoría:</label>
                    <select
                        className="infoField"
                        value={form.idCategoria || ''}
                        onChange={(e) => handleChange('idCategoria', e.target.value ? parseInt(e.target.value) : null)}
                    >
                        <option value="">Sin Categoría</option>
                        {categorias.map(c => (
                            <option key={c.idCategoria} value={c.idCategoria}>{c.nombre}</option>
                        ))}
                    </select>
                </div>
            </div>

            <div>
                <label style={labelStyle}>Valor:</label>
                <div style={{ position: 'relative' }}>
                    <textarea
                        className="infoField"
                        style={{ minHeight: '120px', fontFamily: 'monospace', resize: 'vertical' }}
                        value={form.valor}
                        onChange={(e) => handleChange('valor', e.target.value)}
                        placeholder="Valor hexadecimal (#RRGGBB)..."
                    />
                    <div style={{ position: 'absolute', bottom: '15px', right: '15px' }}>
                        <input
                            type="color"
                            value={form.valor.startsWith('#') ? form.valor : '#ffffff'}
                            onChange={(e) => handleChange('valor', e.target.value)}
                            style={{ width: '36px', height: '36px', border: 'none', background: 'transparent', cursor: 'pointer', padding: 0 }}
                            title="Seleccionar color"
                        />
                    </div>
                </div>
            </div>

        </div>
    );

    const Footer = (
        <div
            style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '.8rem',
                marginTop: '2rem',
                paddingRight: '2rem', // Alineado con el body
                flex: '0 0 auto',
            }}
        >
            <button className="roles-btn" onClick={onClose}>Cancelar</button>
            <button
                className="btn-action"
                onClick={() => onSubmit(form, mode)}
                disabled={!isFormValid}
                style={{
                    opacity: !isFormValid ? 0.5 : 1,
                    cursor: !isFormValid ? 'not-allowed' : 'pointer',
                }}
            >
                {mode === 'new' ? 'Guardar' : 'Actualizar'}
            </button>
        </div>
    );

    return (
        <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {Header}
            {Body}
            {Footer}
        </div>
    );
}
